// extracted by mini-css-extract-plugin
export default {"popup":"dEbuxucOCmwm6iyKrYAE","triangle":"lrBM1IqSDUPumwwIXfkq"};